import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import ViewAllSell from "./ViewAllSell";
import {
  change_Lang,
  EveryTimeTo_English,
} from "../../../actions/Helper_action";
import {
  Get_List_All_Sell_Contracts,
  Update_SellContract,
  View_All_Sell_Contract,
  View_Sell_Contract,
} from "../../../actions/Invoice_action";
export class View_AllSell extends Component {
  render() {
    const {
      sell_all_view_obj,
      lang,
      change_Lang,
      EveryTimeTo_English,
      Update_SellContract,
      index_all_sell,
      name_arb,
      name_en,
      name_krd,
      onClose,
      Get_List_All_Sell_Contracts,
    } = this.props;
    return (
      <Fragment>
        <ViewAllSell
          sell_all_view_obj={sell_all_view_obj}
          lang={lang}
          change_Lang={change_Lang}
          View_Sell_Contract={this.props.View_Sell_Contract}
          EveryTimeTo_English={EveryTimeTo_English}
          Update_SellContract={Update_SellContract}
          index_all_sell={index_all_sell}
          name_arb={name_arb}
          name_en={name_en}
          name_krd={name_krd}
          onClose={onClose}
          Get_List_All_Sell_Contracts={Get_List_All_Sell_Contracts}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    sell_all_view_obj: state.InvoiceReducer.sell_all_view_obj,
    lang: state.HelperReducer.lang,
    all_sell_contracts: state.InvoiceReducer.all_sell_contracts,
    index_all_sell: state.InvoiceReducer.index_all_sell,
    name_krd: state.HelperReducer.name_krd,
    name_arb: state.HelperReducer.name_arb,
    name_en: state.HelperReducer.name_en,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    EveryTimeTo_English: (keys) => dispatch(EveryTimeTo_English(keys)),
    View_Sell_Contract: (id) => dispatch(View_Sell_Contract(id)),
    Update_SellContract: (id, data) => dispatch(Update_SellContract(id, data)),
    View_All_Sell_Contract: (id, index) =>
      dispatch(View_All_Sell_Contract(id, index)),
    Get_List_All_Sell_Contracts: () => dispatch(Get_List_All_Sell_Contracts()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View_AllSell);
